import {SketchPicker} from "react-color";
import React from "react";

export const ColourPicker = (props) => {

    const {shown} = props;
    const {name} = props;
    const {value} = props;
    const {callback} = props;

    function handleCallback(action, data) {
        if (callback) {
            callback(action, data);
        }
    }

    // RENDER

    let pickerElem = [];
    if (shown) {
        pickerElem = (
            <div className="popover" style={{left: 0}}>
                <div className="cover" onClick={() => handleCallback("blur", name)}/>

                <SketchPicker
                    color={value ? value : undefined}
                    onChange={(color) => handleCallback("change", {
                        name,
                        color
                    })}/>
            </div>
        );
    }

    return (
        <div className="input-group-button color-picker">
            <div style={{position: "relative"}}>
                <div
                    className="swatch"
                    onFocus={() => handleCallback("focus", name)}
                    onClick={() => handleCallback("focus", name)}
                >
                    <div className="color" style={{backgroundColor: value || "transparent"}}/>
                </div>

                {pickerElem}
            </div>
        </div>
    );

}